/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProgramMaturityInitiativeRefDto } from './ProgramMaturityInitiativeRefDto';
import {
    ProgramMaturityInitiativeRefDtoFromJSON,
    ProgramMaturityInitiativeRefDtoFromJSONTyped,
    ProgramMaturityInitiativeRefDtoToJSON,
    ProgramMaturityInitiativeRefDtoToJSONTyped,
} from './ProgramMaturityInitiativeRefDto';

/**
 * 
 * @export
 * @interface ProgramMaturityControlRowDto
 */
export interface ProgramMaturityControlRowDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlRowDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlRowDto
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof ProgramMaturityControlRowDto
     */
    maturityScore?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlRowDto
     */
    dataSource?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityControlRowDto
     */
    rowStatusLabel?: string;
    /**
     * 
     * @type {Array<ProgramMaturityInitiativeRefDto>}
     * @memberof ProgramMaturityControlRowDto
     */
    initiatives?: Array<ProgramMaturityInitiativeRefDto>;
}

/**
 * Check if a given object implements the ProgramMaturityControlRowDto interface.
 */
export function instanceOfProgramMaturityControlRowDto(value: object): value is ProgramMaturityControlRowDto {
    return true;
}

export function ProgramMaturityControlRowDtoFromJSON(json: any): ProgramMaturityControlRowDto {
    return ProgramMaturityControlRowDtoFromJSONTyped(json, false);
}

export function ProgramMaturityControlRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramMaturityControlRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'title': json['title'] == null ? undefined : json['title'],
        'maturityScore': json['maturityScore'] == null ? undefined : json['maturityScore'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'rowStatusLabel': json['rowStatusLabel'] == null ? undefined : json['rowStatusLabel'],
        'initiatives': json['initiatives'] == null ? undefined : ((json['initiatives'] as Array<any>).map(ProgramMaturityInitiativeRefDtoFromJSON)),
    };
}

export function ProgramMaturityControlRowDtoToJSON(json: any): ProgramMaturityControlRowDto {
    return ProgramMaturityControlRowDtoToJSONTyped(json, false);
}

export function ProgramMaturityControlRowDtoToJSONTyped(value?: ProgramMaturityControlRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'title': value['title'],
        'maturityScore': value['maturityScore'],
        'dataSource': value['dataSource'],
        'rowStatusLabel': value['rowStatusLabel'],
        'initiatives': value['initiatives'] == null ? undefined : ((value['initiatives'] as Array<any>).map(ProgramMaturityInitiativeRefDtoToJSON)),
    };
}

